<template>
	<div class="tw-flex tw-h-full tw-flex-col tw-justify-between">
		<div v-if="!isConfirmed">
			<div>
				<div class="tw-mb-3 tw-text-[32px] tw-font-bold tw-text-gray-950">
					{{ $t('integrations.add-products') }}
				</div>
				<div class="tw-text-2xl tw-font-medium tw-text-gray-950">
					{{ $t('integrations.add-the-products-that-you-want-to-sell-on-whatsapp') }}
				</div>
			</div>

			<div class="tw-mt-4">
				<template v-for="item in data">
					<AppRadio
						class="tw-mb-2"
						v-model="selectedVal"
						:value="item.value"
						customClasses="tw-items-start tw-gap-3"
					>
						<template v-slot:label="{ check }">
							<div @click="check()">
								<p class="tw-text-lg tw-font-medium tw-text-gray-700">
									{{ $t(item.title) }}
								</p>
								<p class="tw-text-lg tw-text-gray-600">
									{{ $t(item.subTitle) }}
								</p>
							</div>
						</template>
					</AppRadio>
				</template>
			</div>

			<div class="tw-mt-7 tw-flex tw-gap-3">
				<AppButton
					:label="$t('integrations.skip-step')"
					size="xl"
					class="tw-rounded-full"
					type="button"
					@click="skipStep"
					:disabled="skipStepLoading"
					:loading="skipStepLoading"
					secondary
					variant="gray"
				/>

				<AppButton
					:label="$t('integrations.confirm')"
					size="xl"
					class="tw-rounded-full"
					variant="brand"
					customClasses="tw-gap-3"
					@click="confirm"
					:disabled="loading"
					:loading="loading"
				/>
			</div>
		</div>

		<template v-else>
			<!--			<SyncWhatsAppLinker v-if="selectedVal == '1'" />-->
			<AddManually v-if="selectedVal == 'add_manually'" />
		</template>

		<div v-if="configs.brand == 'Linker'" class="tw-mt-7 tw-flex tw-justify-end">
			<a :href="needHelpUrl" target="_blank">
				<AppButton
					:label="$t('integrations.need-help')"
					variant="secondary"
					endIcon="assets/v2/image/icons/help-circle.svg"
					class="tw-rounded-full"
					size="xl"
				/>
			</a>
		</div>
	</div>
</template>

<script setup>
// import SyncWhatsAppLinker from './sync-whatsapp-linker';
import AddManually from './add-manually';

import { ref } from 'vue';
import { useLinkMarketplaceStore } from '@/v2/modules/integrations/stores/link-marketplace';
import { Marketplace } from '@/v2/modules/integrations/entities/marketplace';
import { Alert } from '@/v2/plugins/alert';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { configs } from '@/v2/system-configs';

const linkMarketplaceStore = useLinkMarketplaceStore();

const { t } = useI18n();
const needHelpUrl = 'https://www.linker.com.sa/help-center-articles-ar/how-to-upload-products-to-a-whatsapp-catalog';
const skipStepLoading = ref(false);
const selectedVal = ref(null);
const isConfirmed = ref(false);
const loading = ref(false);
const router = useRouter();

const data = [
	{
		title: 'integrations.import-products-from-whatsapp-to-linker',
		subTitle: 'integrations.select-this-if-you-have-existing-products-in-your-whatsapp-catalog',
		value: 'import_products',
	},
	{
		title: 'integrations.add-products-manually-using-an-excel-sheet',
		subTitle: 'integrations.select-this-if-you-want-to-upload-your-products-manually',
		value: 'add_manually',
	},
	{
		title: 'integrations.sync-products-between-sales-channels-linked-on-linker',
		subTitle:
			'integrations.select-this-if-you-want-to-sync-products-from-any-of-your-linked-channels-to-whatsapp',
		value: 'sync_products',
	},
];

const confirm = async () => {
	if (!selectedVal.value) {
		Alert.error(t('integrations.please-select-one-option'));
		return;
	}

	if (selectedVal.value == 'import_products') {
		importProducts();
		return;
	} else if (selectedVal.value == 'sync_products') {
		syncProducts();
		return;
	}

	isConfirmed.value = true;
};

const importProducts = async () => {
	loading.value = true;
	try {
		await Marketplace.importProducts(linkMarketplaceStore.linkedMarketplaceId);
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
		router.push('/v2/integrations/marketplaces');
	} finally {
		loading.value = false;
	}
};

const syncProducts = async () => {
	window.open(`${window.location.origin}/v2/products/list`, '_blank');
	await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
	await linkMarketplaceStore.refetchSteps();
	router.push('/v2/integrations/marketplaces');
};

const skipStep = async () => {
	skipStepLoading.value = true;
	try {
		await Marketplace.finishWizardStep(linkMarketplaceStore.currentStepData.id);
		await linkMarketplaceStore.refetchSteps();
        router.push('/v2/integrations/marketplaces');
	} finally {
		skipStepLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
